import Contact from './Contact.jsx';

export default Contact;
